<script lang="ts">
	import { fade } from 'svelte/transition';
	import * as Table from '$lib/components/ui/table';
	import { PUBLIC_CDN_URL, PUBLIC_LOL_CDN_URL } from '$env/static/public';
	import { cn } from '$lib/utils';
	import GuiToolbar from '../gui-toolbar.svelte';

	let latestLoLPatch = '14.22';
	let className: string = '';

	export { className as class };
</script>

<div
	class={cn(
		'relative h-[850px] w-[640px] flex-col items-center rounded-lg border border-darkTertiary bg-darkPrimaryAlt px-5 py-2 shadow-lg backdrop-blur',
		className
	)}
>
	<GuiToolbar class="h-2.5 w-auto" />
	<div class="flex h-full w-full">
		<div class="flex h-full w-full flex-col items-center justify-center">
			<div
				class={cn('flex h-full w-full max-w-4xl flex-col items-start justify-start gap-6 py-10')}
			>
				<div class="flex w-full flex-row items-start justify-start gap-3">
					<div
						class="flex h-8 max-h-7 min-h-7 w-7 min-w-7 max-w-9 overflow-hidden rounded-full bg-darkQuaternary pt-0.5 shadow-glow shadow-darkQuaternary drop-shadow-lg transition-all"
					>
						<img
							src={`${PUBLIC_CDN_URL}/meeko/meeko_1.png?fm=webp`}
							class="block h-9 max-h-9 w-auto object-cover p-1"
							alt="Meeko"
						/>
					</div>
					<div class="flex w-full flex-col items-start justify-start gap-1">
						<span class="text-xs font-light text-lightTertiary">Meeko</span>

						<div
							in:fade={{ duration: 300 }}
							class="flex w-full flex-col items-start justify-center gap-3 pr-12"
						>
							<p class="max-w-xl text-xs text-lightSecondary">
								Absolutely, here is the latest tier list for ADC on <span
									class="font-medium text-primary">Patch {latestLoLPatch || '14.12.1'}</span
								>. This tier list is based on win rates, pick rates and ban rates, remember that
								while tier lists are a good starting point, the best champion for you will also
								depend on your personal playstyle and comfort with the champion's mechanics.
							</p>
							<!-- Tier List -->
							<div
								class="flex h-auto w-full flex-col items-center justify-center overflow-x-scroll rounded-lg border border-darkQuaternary bg-darkTertiary"
							>
								<Table.Root>
									<Table.Header>
										<Table.Row>
											<Table.Head class="h-8 w-[140px]">Hero</Table.Head>
											<Table.Head class="h-8 text-center">Tier</Table.Head>
											<Table.Head class="h-8 text-center">Win rate</Table.Head>
											<Table.Head class="h-8 text-center">Ban rate</Table.Head>
											<Table.Head class="h-8 text-center">Games played</Table.Head>
										</Table.Row>
									</Table.Header>
									<Table.Body class="bg-darkSecondary text-xs">
										<Table.Row>
											<Table.Cell class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/Draven.png?fm=webp`}
													class="inline h-6 w-auto rounded-full border border-darkQuaternary"
													alt="Draven"
												/>Draven
											</Table.Cell>
											<Table.Cell class="text-center">S</Table.Cell>
											<Table.Cell class="text-center">50.23%</Table.Cell>
											<Table.Cell class="text-center">7.2%</Table.Cell>
											<Table.Cell class="text-center">27.9%</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/Vayne.png?fm=webp`}
													class="inline h-6 w-auto rounded-full border border-darkQuaternary"
													alt="Vayne"
												/>Vayne
											</Table.Cell>
											<Table.Cell class="text-center">S</Table.Cell>
											<Table.Cell class="text-center">52.11%</Table.Cell>
											<Table.Cell class="text-center">8.9%</Table.Cell>
											<Table.Cell class="text-center">8.3%</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/TwistedFate.png?fm=webp`}
													class="inline h-6 w-auto rounded-full border border-darkQuaternary"
													alt="Twisted Fate"
												/>Twisted Fate
											</Table.Cell>
											<Table.Cell class="text-center">S</Table.Cell>
											<Table.Cell class="text-center">53.41%</Table.Cell>
											<Table.Cell class="text-center">3.9%</Table.Cell>
											<Table.Cell class="text-center">19.5%</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/Twitch.png?fm=webp`}
													class="inline h-6 w-auto rounded-full border border-darkQuaternary"
													alt="Twitch"
												/>Twitch
											</Table.Cell>
											<Table.Cell class="text-center">S</Table.Cell>
											<Table.Cell class="text-center">52.63%</Table.Cell>
											<Table.Cell class="text-center">6.0%</Table.Cell>
											<Table.Cell class="text-center">3.2%</Table.Cell>
										</Table.Row>
										<Table.Row>
											<Table.Cell class="flex flex-row items-center gap-2">
												<img
													src={`${PUBLIC_LOL_CDN_URL}/champion/MissFortune.png?fm=webp`}
													class="inline h-6 w-auto rounded-full border border-darkQuaternary"
													alt="Miss Fortune"
												/>Miss Fortune
											</Table.Cell>
											<Table.Cell class="text-center">S</Table.Cell>
											<Table.Cell class="text-center">50.61%</Table.Cell>
											<Table.Cell class="text-center">8.5%</Table.Cell>
											<Table.Cell class="text-center">8.5%</Table.Cell>
										</Table.Row>
									</Table.Body>
								</Table.Root>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
